function redirectToLogin(baseUrl, redirectUrl) {
  baseUrl = baseUrl || window.ENTRO_AUTH_URI;
  redirectUrl = redirectUrl || encodeURIComponent(window.location.href);
  const uri = getRedirectToLoginUrl(baseUrl, redirectUrl);

  sessionStorage.clear();
  window.location.href = uri;
}

function redirectToLogout(baseUrl, destinationUrl) {
  const uri = getRedirectToLogoutUrl(baseUrl, destinationUrl);

  sessionStorage.clear();
  window.location.href = uri;
}

function redirectToCustomerSelection(baseUrl, origin) {
  const uri = getRedirectToCustomerSelectionUrl(baseUrl, origin);

  sessionStorage.clear();
  window.location.href = uri;
}

function getRedirectToLoginUrl(baseUrl, redirectUrl) {
  if (!baseUrl) throw Error('Invalid baseUrl');

  const redirectParam = redirectUrl ? `?redirect_uri=${redirectUrl}` : '';
  return `${baseUrl}/id${redirectParam}`;
}

function getRedirectToLogoutUrl(baseUrl, destinationUrl) {
  if (!baseUrl) throw Error('Invalid baseUrl');

  const destParam = destinationUrl ? `?dest=${destinationUrl}` : '';
  return `${baseUrl}/logout${destParam}`;
}

function getRedirectToCustomerSelectionUrl(baseUrl, origin) {
  if (!baseUrl) throw Error('Invalid baseUrl');

  const originParam = origin ? `?origin=${origin}` : '';
  return `${baseUrl}/customer/login${originParam}`;
}

export default {
  redirectToLogin,
  redirectToLogout,
  redirectToCustomerSelection,
  getRedirectToLoginUrl,
  getRedirectToLogoutUrl,
  getRedirectToCustomerSelectionUrl
};
